import { render, staticRenderFns } from "./HomeMyMessage.vue?vue&type=template&id=9455b6ba&scoped=true"
import script from "./HomeMyMessage.vue?vue&type=script&lang=js"
export * from "./HomeMyMessage.vue?vue&type=script&lang=js"
import style0 from "./HomeMyMessage.vue?vue&type=style&index=0&id=9455b6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9455b6ba",
  null
  
)

export default component.exports